module["exports"] = ["#{prefix} #{Name.first_name}", "#{Name.first_name} #{suffix}"];